// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2YvQN","logo":"Footer_logo__3wlN4"};